import GetPiCities from 'components/get-pi-cities/get-pi-cities';

export default GetPiCities;
